import { Grid, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { _COLORS } from "../../../utils/_constants";
import { _STYLES } from "../../../utils/_style_constants";
import { editInstantRequest } from "../../../utils/formHelper";
import _ from "lodash";

const DescriptionBienLettreIntentionAchat = ({
  register,
  errors,
  currentMandat,
  setCurrentMandat,
  refresh,
  disabledSign = false,
}) => {
  useEffect(() => {
    setComposeDe(currentMandat?.bien?.composition);
  }, [currentMandat]);

  const [composeDe, setComposeDe] = useState("");

  return (
    <>
      <Grid
        container
        columnSpacing={1}
        rowSpacing={1}
        padding={4}
        sx={{ alignItems: "center" }}
      >
        <Grid item xs={12}>
          <Typography
            variant="h5"
            style={{
              fontWeight: "bold",
              color: _COLORS.primary,
            }}
          >
            Description du bien
          </Typography>
        </Grid>
        <Grid item md={2} xs={12}>
          <Typography noWrap sx={{ ..._STYLES.typographyLabelTitle }}>
            Adresse du bien*
          </Typography>
        </Grid>
        <Grid item md={10} xs={12}>
          <TextField
            disabled={disabledSign}
            fullWidth
            size="large"
            multiline={true}
            rows={3}
            id="adressBien"
            label="Adresse du bien"
            value={
              currentMandat?.bien?.adresse ? currentMandat.bien.adresse : ""
            }
            // Besoin de changer la valeur du state pour que le composant se rafraichisse
            onChange={(e) => {
              setCurrentMandat({
                ...currentMandat,
                bien: {
                  ...currentMandat.bien,
                  adresse: e.target.value,
                },
              });
            }}
            // On envoie la valeur au serveur
            onBlur={(e) => {
              let m = editInstantRequest(
                e.target.value,
                currentMandat.bien["@id"],
                "adresse",
              );

              refresh();
            }}
            helperText={
              errors?.biens?.adresse?.type === "required" && (
                <Typography sx={_STYLES.errorMessage}>
                  Adresse est requis
                </Typography>
              )
            }
          />
        </Grid>

        <Grid item md={2} xs={12}>
          <Typography noWrap sx={{ ..._STYLES.typographyLabelTitle }}>
            Composé de*
          </Typography>
        </Grid>
        <Grid item md={10} xs={12}>
          <TextField
            disabled={disabledSign}
            fullWidth
            size="large"
            multiline={true}
            rows={5}
            id="composition"
            value={composeDe}
            label="Composition du bien"
            // Besoin de changer la valeur du state pour que le composant se rafraichisse
            onChange={(e) => {
              setComposeDe(e.target.value);
            }}
            // On envoie la valeur au serveur
            onBlur={(e) => {
              let m = editInstantRequest(
                e.target.value,
                currentMandat.bien["@id"],
                "composition",
              );

              refresh();
            }}
          />
        </Grid>

        <Grid item md={2} xs={12}>
          <Typography sx={{ ..._STYLES.typographyLabelTitle }}>
            Ledit bien appartenant à*
          </Typography>
        </Grid>
        <Grid item md={4} xs={12}>
          <TextField
            disabled={disabledSign}
            size="small"
            fullWidth
            id="priporietaire"
            value={
              currentMandat?.bien?.proprietaire
                ? currentMandat.bien.proprietaire
                : ""
            }
            {...register("biens.proprietaire", {
              required: true,
            })}
            // Besoin de changer la valeur du state pour que le composant se rafraichisse
            onChange={(e) => {
              setCurrentMandat({
                ...currentMandat,
                bien: {
                  ...currentMandat.bien,
                  proprietaire: e.target.value,
                },
              });
            }}
            // On envoie la valeur au serveur
            onBlur={(e) => {
              let m = editInstantRequest(
                e.target.value,
                currentMandat.bien["@id"],
                "proprietaire",
              );

              refresh();
            }}
          />
        </Grid>
        <Grid item md={6} />
      </Grid>
    </>
  );
};

export default DescriptionBienLettreIntentionAchat;
